module.exports = __webpack_public_path__ + "img/nu.e5e72405.svg";